<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
import { recordVisitCount } from './api/statistics.js'

export default {
  name: 'app',
  mounted() {
    this.handleVisitTracking();
  },
  methods: {
    // 处理访问统计
    handleVisitTracking() {
      try {
        // 检测是否为刷新操作
        if (this.isPageRefresh()) {
          console.log('检测到页面刷新，跳过访问统计');
          return;
        }

        // 检查30分钟内是否已经访问过
        if (this.isRecentVisitor()) {
          console.log('30分钟内已访问过，跳过访问统计');
          return;
        }

        // 调用访问统计接口
        this.recordVisit();
      } catch (error) {
        console.error('访问统计处理出错:', error);
      }
    },

    // 检测是否为页面刷新
    isPageRefresh() {
      // 方法1: 使用performance.navigation API（推荐）
      if (performance.navigation) {
        return performance.navigation.type === performance.navigation.TYPE_RELOAD;
      }
      
      // 方法2: 使用performance.getEntriesByType作为备选
      const navigationEntries = performance.getEntriesByType('navigation');
      if (navigationEntries.length > 0) {
        return navigationEntries[0].type === 'reload';
      }
      
      return false;
    },

    // 检查是否为30分钟内的重复访客
    isRecentVisitor() {
      const lastVisitTime = localStorage.getItem('lastVisitTime');
      if (!lastVisitTime) {
        return false;
      }

      const now = Date.now();
      const lastVisit = parseInt(lastVisitTime);
      const thirtyMinutes = 30 * 60 * 1000; // 30分钟的毫秒数

      return (now - lastVisit) < thirtyMinutes;
    },

    // 记录访问
    async recordVisit() {
      try {
        await recordVisitCount();
        console.log('访问统计记录成功');
        
        // 记录当前访问时间
        localStorage.setItem('lastVisitTime', Date.now().toString());
      } catch (error) {
        console.error('访问统计记录失败:', error);
      }
    }
  }
}
</script>

<style>
    * {
        margin: 0;
        padding: 0;
    }
    body::-webkit-scrollbar {
        display: none; /* Chrome、Safari等WebKit内核浏览器隐藏滚动条 */
    }
    body {
        scrollbar-width: none; /* Firefox隐藏滚动条 */
    }
    html::-webkit-scrollbar {
        width: 0;
    }
    body::-webkit-scrollbar {
        width: 0;
    }
    /* 隐藏 IE 和 Edge 浏览器的滚动条 */
    ::-ms-scrollbar {
        width: 0;
    }
</style>
